import React from "react";
import Button from "../../atoms/Button";
import { ReactComponent as Logo } from "../../svgs/logo.svg";
import SignupWall from "../../organisms/SignupWall";
import LoginForm from "../../organisms/LoginForm";
import { Link } from "react-router-dom";
import { ReactComponent as Arrow } from "../../../components/svgs/back-arrow.svg";

const Login = ({ portal }) => {
  const textColor = {
    seller: "text-black",
    buyer: "text-black",
    trader: "text-black",
  };
  return (
    <div className="flex">
      <div className="shrink-0 grow-0 basis-[40%] h-auto relative ">
        <SignupWall portal={portal}>
          <p
            className={`${textColor[portal]} text-center text-lg leading-10 mb-4`}
          >
            Don't have an account
          </p>
          <Link to={"sign-up"}>
            <Button
              color="white"
              varient="rounded"
              className="w-fit py-2 px-8 mx-auto text-2xl font-medium tracking-widest"
            >
              Create account
            </Button>
          </Link>
        </SignupWall>
      </div>

      <div className="shrink-0 grow-0 basis-[60%]">
        <div className="shrink-0 grow-0 flex flex-col items-left">
          <Link to={"/"}>
            <Button
              varient="rounded"
              borderColor="black"
              className="w-auto justify-center px-2.5 py-2 mt-6 ml-10 text-black  bg-white border border-black  hover:bg-gray-50  "
            >
              <div className="flex">
                <Arrow className="w-5 text-black" />
                <div className="font-bold text-sm pl-1 pr-2">Back to home</div>
              </div>
            </Button>
          </Link>
        </div>
        <div className="shrink-0 grow-0 flex flex-col items-center px-32 py-11 ">
          <Logo />

          <h2 className="text-4xl mt-6">Log in Account</h2>
          <p className="text-sm text-gray-500 mt-4">
            Please Log in to your Offsetgo account
          </p>

          <LoginForm userType={portal} />
        </div>
      </div>
    </div>
  );
};

export default Login;
